/**
 * Logger Utility
 * Safe logging that is silent in production except for errors.
 */

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  debug: (...args) => {
    if (isDev) console.log(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  }, // errors always log
};

export default logger;

// Keep safeLog for backward compatibility with filesService.js
export const safeLog = (level = 'log', ...args) => {
  if (isDev) {
    console[level](...args);
  }
};
